import { blue, green } from "@ant-design/colors";
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Flex, Row, Space, Spin, Typography } from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification } from "common";
import Prefixs from "common/Prefixs";
import { formatterNumber } from "helpers/formatNumber";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";

export default function ChangeInfoSuccessCompensation({
  dataPayment,
  dataDetail,
  dataDetailCompensation,
}) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const onHandlePay = async () => {
    const CHANGE_INFO = 4;
    history.push(
      `${Prefixs.ORDER_PAYMENT}?object=${CHANGE_INFO}&type=${dataDetail?.type}&requestId=${dataDetailCompensation.id}`
    );

    // setLoading(true);
    // try {
    //   const PAID = 2;
    //   const res = await ServiceApi.updateStatusPayment({
    //     requestId: dataDetailCompensation.id,
    //     status: PAID,
    //     object: CHANGE_INFO,
    //   });
    //   if (res && res.status === 200 && res.data.status === 200) {

    //   }
    // } catch (error) {
    //   console.error("error: ", error);
    //   showNotification("error", error.message, "Thông báo");
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Flex justify="center" className="my-5">
        <Space direction="vertical" align="center">
          <Flex justify="center">
            <Button
              type="primary"
              style={{ background: green.primary }}
              shape="circle"
              size="large"
              icon={<CheckOutlined />}
            />
          </Flex>
          <div className="text-center">
            <Typography.Title level={4}>
              Yêu cầu đã gửi thành công đến FastCA
            </Typography.Title>
          </div>
          <div className="">
            <div>
              Để thực hiện
              <Typography.Text strong> Điều chỉnh thông tin </Typography.Text>
              chứng thư số USB Token thành công, Quý khách vui lòng thực hiện
              các bước sau:
            </div>
            <br />
            <Space direction="vertical" className="ml-5">
              <div>
                <Typography.Text strong>Bước 1: </Typography.Text>
                Thực hiện thanh toán phí điều chỉnh thông tin chứng thư số là
                <Typography.Text strong className="font-lg">
                  {" "}
                  {formatterNumber(dataPayment?.totalPayment)} VNĐ{" "}
                </Typography.Text>
                VNĐ (Đã bao gồm VAT)
              </div>
              <div>
                <Typography.Text strong>Bước 2: </Typography.Text>
                Kiểm tra kết quả xử lý yêu cầu Điều chỉnh thông tin chứng thư số
                được gửi về Email của Quý khách, trong thời gian 02 giờ làm việc
                kể từ thời điểm thanh toán phí hoàn tất.
              </div>
              <div>
                <Typography.Text strong>Bước 3: </Typography.Text>
                Rút token cắm lại để cập nhật chứng thư số đã Điều chỉnh thông
                tin
              </div>
              <div>
                <Typography.Text strong>Bước 4: </Typography.Text>
                Gửi yêu cầu xuất hóa đơn VAT đến FastCA (trong 24 giờ) và nhận
                hóa đơn dịch vụ
              </div>
              <div>
                <Typography.Text strong>Bước 5: </Typography.Text>
                Cập nhật 
                <Typography.Text strong>
                {" "}chứng thư số mới{" "}
                </Typography.Text>
                 vào các tài khoản dịch vụ công (như Thuế, Bảo hiểm xã hội, Hải quan, Đấu thầu, Hóa đơn,…) và các ứng dụng dịch vụ phần mềm có sử dụng chứng thư số để tránh gián đoạn trong quá trình sử dụng
              </div>
            </Space>
            <br />
            <br />
            <div>
            Trường hợp không nhận được kết quả hoặc thực hiện không thành công, Quý khách vui lòng liên hệ FastCA để được hỗ trợ nhanh chóng kịp thời
            </div>
            <br />
            <div>
              Bằng việc nhấn
              <Typography.Text strong style={{ color: blue.primary }}> Tiếp tục </Typography.Text>
              Quý khách đồng ý với
              <Typography.Text strong>
                {" "}
                Chính sách đặt hàng và thanh toán{" "}
              </Typography.Text>
              của FastCA, xem chi tiết
              <Typography.Text strong>
                <Typography.Link
                  href={`${dataPayment?.urlChinhSach}`}
                  target="_blank"
                >
                  {" "}
                  TẠI ĐÂY
                </Typography.Link>
                .
              </Typography.Text>
            </div>
          </div>
          <br />
          <Row>
            <Link
              to={`${Prefixs.ORDER_PAYMENT}?object=4&type=${dataDetail?.type}&requestId=${dataDetailCompensation.id}`}
            >
              <Button type="primary" htmlType="submit">
                Tiếp tục
              </Button>
            </Link>
          </Row>
        </Space>
      </Flex>
    </Spin>
  );
}
